<template>
  <MetaButton data-testid="item-views" tooltip="Analytics" tooltip-placement="top-start" @click.prevent="openAnalytics">
    <MetadataIcon name="eye" />
    <span>{{ visitsMessage }}</span>
  </MetaButton>
</template>
<script lang="ts" setup>
import { computed, nextTick } from 'vue';
import MetadataIcon from '@/modules/viewer/components/meta_buttons/MetadataIcon.vue';
import { useViewerItemStore } from '@/modules/viewer/store/useViewerItemStore';
import { useViewerModeStore, ViewerMode } from '@/modules/viewer/store/useViewerModeStore';
import MetaButton from '@/modules/viewer/components/MetaButton.vue';
import { storeToRefs } from 'pinia';
import { useActiveTabTrigger } from '../../composables/useActiveTab';

const { publicVisitsCount } = storeToRefs(useViewerItemStore());
const viewerModeStore = useViewerModeStore();
const { requestTab } = useActiveTabTrigger();

const openAnalytics = async () => {
  if (viewerModeStore.isSummaryMode) {
    viewerModeStore.setMode(ViewerMode.VIDEO);
    await nextTick();
  }

  requestTab('#analytics', { alwaysScroll: true });
};

const visitsMessage = computed(() => {
  return publicVisitsCount.value === 1 ? `1 view` : `${publicVisitsCount.value} views`;
});
</script>
